import PrivacyNoticeBanner from './privacyNoticeBanner'

export default PrivacyNoticeBanner
